/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Breadcrumb_LabelInputs */

const de_account_breadcrumb_label = /** @type {(inputs: Account_Breadcrumb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/** @type {(inputs: Account_Breadcrumb_LabelInputs) => LocalizedString} */
const en_account_breadcrumb_label = de_account_breadcrumb_label;

/**

* @param {Account_Breadcrumb_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_breadcrumb_label = /** @type {((inputs?: Account_Breadcrumb_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Breadcrumb_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_breadcrumb_label(inputs)
	return en_account_breadcrumb_label(inputs)
});